import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../components/alert/swal";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import ContainerLayout from "../../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../../components/state-component/StateComponents";
import { debouncedApiCall } from "../../../../utils/app.utils";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import TableCustom from "../../../../components/table/tableCustom";
import ModalCustom from "../../../../components/modal/ModalCustom";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import AutocompleteSelect from "../../../../components/select/autoCompleteSelect";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import UploadAvatar from "../../../../components/upload/UploadAvatar";
import { edpexResponsibleAPI } from "../../../../api/edpex-responsible/edpex-responsible.api";

const EdpexAddResponsiblePerson = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(13);
  const [sortBy, setSortBy] = useState<string>("modified_date");
  const [sortType, setSortType] = useState<string>("DESC");
  const [search, setSearch] = useState<string>("");
  const [id_item, set_id_item] = useState<number | null>(null);
  const [data, setData] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [formState, setFormState] = useState<{
    id_employee: number;
    name: string;
    id_department: number;
    department_name: string;
    employee_no: string;
    position: string;
  }>({
    id_employee: 0,
    name: "",
    id_department: 0,
    department_name: "",
    employee_no: "",
    position: "",
  });
  const [imagePath, setImagePath] = useState<string>("");

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getDataEmployeeById = async (id: number) => {
    const res = await EmployeeApi.getOne(id);
    const data = res.data;
    if (data.status < 300) {
      setImagePath(data.data?.employee_image[0]?.file_path ?? "");
    } else {
      setImagePath("");
    }
  };

  useEffect(() => {
    getDataEmployee();
  }, []);

  const handleCloseModal = () => {
    setShowModal("");
    setFormState({
      id_employee: 0,
      name: "",
      id_department: 0,
      department_name: "",
      employee_no: "",
      position: "",
    });
    set_id_item(null);
  };
  const handleShowModal = (mode: string) => {
    setShowModal(mode);
  };
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "นามสกุล",
      width: 200,
      sortable: true,
      disablePadding: false,
      align: "center",
      label: t("ชื่อ - นามสกุล"),
    },
    {
      id: "เลขประจำตัวเจ้าหน้าที่",
      disablePadding: false,
      width: 100,
      sortable: true,
      align: "left",
      label: t("เลขประจำตัวเจ้าหน้าที่"),
    },
    {
      id: "ตำแหน่งงาน",
      disablePadding: false,
      align: "center",
      width: 150,
      label: t("ตำแหน่งงาน"),
    },
    {
      id: "หน่วยงาน",
      disablePadding: false,
      align: "center",
      width: 141,
      label: t("หน่วยงาน"),
    },
    {
      id: "ผู้ปรับปรุงล่าสุด",
      disablePadding: false,
      align: "center",
      width: 257,
      label: t("ผู้ปรับปรุงล่าสุด"),
    },
    {
      id: "วันที่ปรับปรุงล่าสุด",
      disablePadding: false,
      align: "center",
      width: 257,
      label: t("วันที่ปรับปรุงล่าสุด"),
    },
    {
      id: "s",
      disablePadding: false,
      align: "center",
      width: 100,
      class: matches,
      label: "",
    },
  ];
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_edpex_responsible,
      name,
      id_employee,
      position,
      employee_no,
      department_name_th,
      department_name_eng,
      status,
      modified_name,
      modified_date,
    } = objData;

    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "left",
          label: name || "-",
        },
        { option: "TEXT", align: "center", label: employee_no || "-" },
        {
          option: "TEXT",
          align: "center",
          label: position || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: department_name_th || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label:
            moment(modified_date || new Date())
              .add(543, "year")
              .format("l") ||
            modified_date ||
            "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_name || "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          width: 300,
          component: (
            <OptionsButtonCustom
              enableView
              enableDelete
              onDeleteClick={() => handleDelete(id_edpex_responsible)}
              onViewClick={() => {
                handleShowModal("VIEW");
                set_id_item(id_edpex_responsible);
                setFormState({
                  id_employee: id_employee,
                  name: name,
                  id_department: 0,
                  department_name: department_name_th,
                  employee_no: employee_no,
                  position: position,
                });
              }}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleDelete = (id_item: number) => {
    alertActive(
      t("ลบผู้รับผิดชอบ"),
      t("ต้องการลบผู้รับผิดชอบ"),
      undefined,
      undefined,
      async () => {
        dispatch(setLoading());
        await edpexResponsibleAPI
          .deleteEdpexResponsible(id_item)
          .then((res) => {
            if (res.status < 300) {
              alertSuccess(t("ลบผู้รับผิดชอบ"), t("ลบผู้รับผิดชอบ สำเร็จ"));
              handleGetData();
            }
          })
          .catch((err) => {
            alertError(t("ลบผู้รับผิดชอบ"), t("ลบผู้รับผิดชอบ ไม่สำเร็จ"));
            console.log(err);
          })
          .finally(() => {
            dispatch(unsetLoading());
          });
      }
    );
  };

  const handleSubmit = async () => {
    const body: any = {
      id_employee: formState.id_employee,
      name: formState.name,
      last_name: "",
      id_department: formState.id_department,
      position: formState.position,
    };
    dispatch(setLoading());
    if (id_item) {
      await edpexResponsibleAPI
        .updateEdpexResponsible(id_item, body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("แก้ไขผู้รับผิดชอบ"), t("แก้ไขผู้รับผิดชอบ สำเร็จ"));
            handleGetData();
            handleCloseModal();
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("แก้ไขผู้รับผิดชอบ"), t("แก้ไขผู้รับผิดชอบ ไม่สำเร็จ"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    } else {
      await edpexResponsibleAPI
        .createEdpexResponsible(body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("เพิ่มผู้รับผิดชอบ"), t("เพิ่มผู้รับผิดชอบ สำเร็จ"));
            handleGetData();
            handleCloseModal();
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("เพิ่มผู้รับผิดชอบ"), t("เพิ่มผู้รับผิดชอบ ไม่สำเร็จ"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
  };

  const handleGetData = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
    };
    if (search) query = { ...query, search: search };
    dispatch(setLoading());
    await edpexResponsibleAPI
      .getEdpexResponsibleList(query)
      .then((res) => {
        if (res.status < 300) {
          setData(res.data?.data?.items || []);
          setTotalItems(res.data?.data?.meta?.totalItems || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }, [page, pageLimit, search]);

  useEffect(() => {
    handleGetData();
  }, [handleGetData]);

  return (
    <ContainerLayout
      title={t("เพิ่มผู้รับผิดชอบ")}
      navigateContent={
        <NavigateListCustom
          navigateData={[
            {
              key: "1",
              name: t("ระบบ Edpex"),
              disabled_match: true,
              pathName: routeName.cms.edpexResultDisplay,
            },
            {
              key: "2",
              name: t("เพิ่มผู้รับผิดชอบ"),
              pathName: routeName.cms.edpexAddResponsiblePerson,
            },
          ]}
        />
      }
      content={
        <>
          <div className="w-full flex justify-between">
            <span className="flex-1">
              <StateComponents
                typeProps={[
                  {
                    seq: 1,
                    type: "TEXT_FIELD",
                    gridProps: {
                      xs: 12,
                      md: 4,
                    },
                    fieldProps: {
                      startAdornment: <SearchOutlinedIcon />,
                      placeholder: t(
                        "ค้นหา ชื่อ - นามสกุล/เลขประจำตัวผู้รับผิดชอบ"
                      ),
                      onChange: (e) =>
                        debouncedApiCall({
                          searchItem: e.target.value,
                          setItem: setSearch,
                        }),
                    },
                  },
                ]}
              />
            </span>
            <span>
              <ButtonPrimary
                mode="add"
                onClick={() => handleShowModal("ADD")}
                buttonName={t("เพิ่มผู้รับผิดชอบ")}
              />
            </span>
          </div>
          <div className="mt-10">
            <section className="w-full mt-10">
              <TableCustom
                tableMinWidth={1920}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCells}
                rowCount={totalItems}
                rowsData={
                  data &&
                  data.map((data: any, i: any) => {
                    return renderData(data, i);
                  })
                }
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
              />
            </section>
          </div>

          {showModal && (
            <ModalCustom
              open
              title={
                showModal === "ADD"
                  ? t("เพิ่มผู้รับผิดชอบ")
                  : showModal === "VIEW"
                  ? t("ข้อมูลผู้รับผิดชอบ")
                  : ""
              }
              subTitle={t("PLEASE_SELECT_LIST")}
              onClose={handleCloseModal}
              component={
                <div className="w-full">
                  {showModal !== "VIEW" && (
                    <AutocompleteSelect
                      required
                      heading={"เพิ่มผู้รับผิดชอบ"}
                      freeSolo
                      labelId={"-"}
                      options={dataEmployee ?? []}
                      getOptionLabel={(option: any) =>
                        `${option?.fullname}` || ""
                      }
                      renderOption={(props, option) => (
                        <li {...props}>{`${option?.fullname}`}</li>
                      )}
                      // value={inputValue.adv_employee_id ?? null}
                      onChange={(_, value: any) => {
                        if (value) {
                          getDataEmployeeById(value.id_employee);
                          setFormState({
                            id_employee: value.id_employee,
                            name: value?.first_name + " " + value?.last_name,
                            id_department: value.id_department,
                            department_name: value.department,
                            employee_no: value.employee_no,
                            position: value.position_name,
                          });
                        }
                      }}
                    />
                  )}

                  <br />

                  {formState.id_employee ? (
                    <>
                      <div className="w-full flex justify-center items-center">
                        <UploadAvatar
                          filePath={imagePath ?? ""}
                          onDrop={(data) => {}}
                          file={imagePath ?? null}
                          noClick={true}
                          hiddenDeleteButton={true}
                          onDelete={() => {}}
                        />
                      </div>

                      <br />

                      <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                          {
                            seq: 1,
                            gridProps: {
                              xs: 12,
                            },
                            fieldProps: {
                              disabled: true,
                              value: formState.name,
                              heading: t("ชื่อ-นามสกุล"),
                              placeholder: t("ชื่อ-นามสกุล"),
                              onChange: (e) => {},
                            },
                            type: "TEXT_FIELD",
                          },
                          {
                            seq: 2,
                            gridProps: {
                              xs: 12,
                            },
                            fieldProps: {
                              disabled: true,
                              value: formState.employee_no,
                              heading: t("เลขประจำตัวเจ้าหน้าที่"),
                              placeholder: t("เลขประจำตัวเจ้าหน้าที่"),
                              onChange: (e) => {},
                            },
                            type: "TEXT_FIELD",
                          },
                          {
                            seq: 3,
                            gridProps: {
                              xs: 12,
                            },
                            fieldProps: {
                              disabled: true,
                              value: formState.position,
                              heading: t("ตำแหน่งงาน"),
                              placeholder: t("ตำแหน่งงาน"),
                              onChange: (e) => {},
                            },
                            type: "TEXT_FIELD",
                          },
                          {
                            seq: 3,
                            gridProps: {
                              xs: 12,
                            },
                            fieldProps: {
                              disabled: true,
                              value: formState.department_name,
                              heading: t("หน่วยงาน"),
                              placeholder: t("หน่วยงาน"),
                              onChange: (e) => {},
                            },
                            type: "TEXT_FIELD",
                          },
                        ]}
                      />
                    </>
                  ) : null}

                  <div className="mt-6 w-full flex justify-center gap-4 items-center">
                    <span>
                      <ButtonPrimary
                        mode="del"
                        buttonName={t("BUTTON.CANCEL")}
                        onClick={handleCloseModal}
                      />
                    </span>
                    {showModal !== "VIEW" && (
                      <span>
                        <ButtonPrimary
                          mode="done"
                          buttonName={t("BUTTON.CONFIRM")}
                          disabled={!formState.id_employee}
                          onClick={handleSubmit}
                        />
                      </span>
                    )}
                  </div>
                </div>
              }
            />
          )}
        </>
      }
    />
  );
};

export default EdpexAddResponsiblePerson;
